import React, { useState } from "react";

import { Nav, Navbar, NavDropdown, Dropdown } from "react-bootstrap";
import { connect } from "react-redux";
import { NavLink, useLocation } from "react-router-dom";
import { DotLoader } from "react-spinners";

import Error from "./error";
import logo from "../logos/ai_logo_transparent_background.png";
import "../styles/navBar.css";
import { pages } from "../utilities/constants";

function NavBar(props) {
  const [isExpanded, setIsExpanded] = useState(false);
  const location = useLocation();

  const path = location.pathname.slice(1);
  let viewTitle = pages[path]?.title || "";

  const LinkItem = ({ to, buttonText, eventKey }) => {
    return (
      <Dropdown.Item
        as={NavLink}
        to={to}
        className="dropdown-link"
        onClick={() => setIsExpanded(false)}
      >
        {buttonText}
      </Dropdown.Item>
    );
  };
  const checkActive = (governmentBody) => {
    // slice removes the backslash from the pathname by removing the first char
    const path = location.pathname.slice(1);
    if (governmentBody === "hudson") {
      let hudsonGovBodies = [
        "dutchess",
        "orange",
        "putnam",
        "ulster",
        "westchester",
        "hudson-valley",
        "hudsonvalley",
      ];
      return hudsonGovBodies.includes(path);
    }

    if (governmentBody === "long-island") {
      let longIslandGovBodies = [
        "nassau",
        "nassau-map",
        "suffolk",
        "suffolk-map",
      ];
      return longIslandGovBodies.includes(path);
    }

    if (governmentBody === "senate") {
      let senateGovBodies = ["senate", "", "senate-map"];
      return senateGovBodies.includes(path);
    }

    if (governmentBody === "assembly") {
      let assemblyGovBodies = ["assembly", "assembly-map"];
      return assemblyGovBodies.includes(path);
    }

    if (governmentBody === "nyc-council") {
      let nycCouncilGovBodies = ["nyc-council", "nyc-council-map"];
      return nycCouncilGovBodies.includes(path);
    }

    if (governmentBody === "western-new-york") {
      let westernNewYorkGovBodies = ["buffalo", "erie", "niagara"];
      return westernNewYorkGovBodies.includes(path);
    }

    if (governmentBody === "finger-lakes") {
      let fingerLakesGovBodies = ["rochester", "monroe"];
      return fingerLakesGovBodies.includes(path);
    }

    return path === governmentBody;
  };

  let isFixed = window.location.href.includes("map") ? null : "top";

  return (
    <Navbar expand="lg" fixed={isFixed} expanded={isExpanded}>
      <Navbar.Brand>
        <div>
          <NavLink to="/" className="nav-home-link">
            <img className="nav-logo" src={logo} alt="ai-logo" />
          </NavLink>

          <h3 className="ai-title-container">{viewTitle}</h3>
        </div>

        <Navbar.Toggle
          aria-controls="basic-navbar-nav"
          onClick={() => setIsExpanded(isExpanded ? false : true)}
        />
      </Navbar.Brand>

      <Navbar.Collapse id="basic-navbar-nav">
        <Nav variant="tabs" defaultActiveKey="/">
          <NavDropdown title="SENATE" id="1" active={checkActive("senate")}>
            <LinkItem to="/senate" buttonText="VIEW BY PEOPLE" />

            <Dropdown.Divider />
            <LinkItem to="/senate-map" buttonText="VIEW ON MAP" />
            <Dropdown.Divider />
          </NavDropdown>

          <NavDropdown title="ASSEMBLY" id="2" active={checkActive("assembly")}>
            <LinkItem to="/assembly" buttonText="VIEW BY PEOPLE" />
            <Dropdown.Divider />
            <LinkItem to="/assembly-map" buttonText="VIEW ON MAP" />

            <Dropdown.Divider />
          </NavDropdown>

          <NavDropdown
            title="NYC COUNCIL"
            id="3"
            active={checkActive("nyc-council")}
          >
            <LinkItem to="/nyc-council" buttonText="VIEW BY PEOPLE" />
            <Dropdown.Divider />
            <LinkItem to="/nyc-council-map" buttonText="VIEW ON MAP" />
            <Dropdown.Divider />
          </NavDropdown>

          <NavDropdown
            title="HUDSON VALLEY COUNTIES"
            id="4"
            active={checkActive("hudson")}
          >
            <LinkItem to="/dutchess" buttonText="DUTCHESS" />
            <Dropdown.Divider />
            <LinkItem to="/orange" buttonText="ORANGE" />

            <Dropdown.Divider />
            <LinkItem to="/putnam" buttonText="PUTNAM" />

            <Dropdown.Divider />
            <LinkItem to="/ulster" buttonText="ULSTER" />

            <Dropdown.Divider />
            <LinkItem to="/westchester" buttonText="WESTCHESTER" />
            <Dropdown.Divider />
          </NavDropdown>
          <NavDropdown
            title="LONG ISLAND COUNTIES"
            id="5"
            active={checkActive("long-island")}
          >
            <LinkItem to="/nassau" buttonText="NASSAU" />
            <Dropdown.Divider />
            <LinkItem to="/nassau-map" buttonText="VIEW ON MAP" />
            <Dropdown.Divider />
            <LinkItem to="/suffolk" buttonText="SUFFOLK" />

            <Dropdown.Divider />
            <LinkItem to="/suffolk-map" buttonText="VIEW ON MAP" />
            <Dropdown.Divider />
          </NavDropdown>

          <NavDropdown
            title="WESTERN NY"
            id="6"
            active={checkActive("western-new-york")}
          >
            <LinkItem to="/buffalo" buttonText="BUFFALO" />
            <Dropdown.Divider />
            <LinkItem to="/erie" buttonText="ERIE COUNTY" />
            <Dropdown.Divider />
            <LinkItem to="/niagara" buttonText="NIAGARA COUNTY" />
          </NavDropdown>
          <NavDropdown
            title="FINGER LAKES"
            id="7"
            active={checkActive("finger-lakes")}
          >
            <LinkItem to="/rochester" buttonText="ROCHESTER" />
            <Dropdown.Divider />
            <LinkItem to="/monroe" buttonText="MONROE COUNTY" />
          </NavDropdown>
        </Nav>
      </Navbar.Collapse>

      <div className={props.isLoading ? "" : "not-loading"}>
        <div className="loading-overlay">
          <div className="spinner">
            <DotLoader size={100} color={"rgb(235, 126, 90)"} loading={true} />
          </div>
        </div>
      </div>
      {props.children}
      {props.isError ? <Error /> : null}
    </Navbar>
  );
}

function mapStateToProps(state) {
  let isLoading = state.isLoading;
  let isError = state.isError;

  let path = window.location.pathname.slice(1);

  if (path === "terms-of-service" || path === "privacy-policy") {
    isLoading = false;
    isError = false;
  }

  return {
    isLoading,
    isError,
  };
}
const componentCreator = connect(mapStateToProps);

export default componentCreator(NavBar);
